/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Home/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import NewTaskAction from './NewTaskAction/index'
import React from 'react'
import Tabs from './Tabs/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Home({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Home"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let constantData = fromHelpers.todaysDate('')
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Home.Vertical"
  data-view-path={viewPath}
 style={{'--ml-1-9V2T': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Home.Horizontal"
  data-view-path={viewPath}
 style={{'--pr-2-9V2T': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 weight="medium"
 data="''"
 format="helpers.js todaysDate"
 text={constantData}
/>
<NewTaskAction
  viewPath={`${viewPath}/NewTaskAction`}
/>
</div>
</div>
<div
  data-testid="Home.Horizontal:1"
  data-view-path={viewPath}
 style={{'--bbc-3-9V2T': dtColorsNeutral200,'--pl-4-9V2T': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal1}`}
>
<Tabs
  viewPath={`${viewPath}/Tabs`}
/>
</div>
<div
  data-testid="Home.Vertical:1"
  data-view-path={viewPath}
 style={{'--mt-5-9V2T': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical1}`}
>
<Content
  viewPath={`${viewPath}/Content`}
/>
</div>
{children}
</React.Fragment>)
}